// Localise le nom des kits pour l'affichage : « 50 Personnes » -> « 50 guests » / « 50 شخص ».
// Le nom stocké (FR) reste la source pour l'admin et les commandes.
export const localizeKitName = (name, lang) => {
  if (!name || lang === 'fr') return name;
  const unit = lang === 'ar' ? 'شخص' : 'guests';
  return name.replace(/(\d[\d\s]*?)\s*Personnes/gi, (_, n) => `${n.trim()} ${unit}`);
};
